// Native app versions that server and client both need to agree on.

/**
 * The iOS build that ships the new onboarding (in App Store review, Sept 2026).
 * - Server: once the App Store lists this version, it becomes the iOS minimum,
 *   so everyone on an older build is asked to update (see server/appStoreVersion.ts).
 * - Client: the onboarding only shows on iOS builds at or above it, so people
 *   see it right after they update, not before.
 */
export const IOS_ONBOARDING_VERSION = "1.3.3";

/** Compares dotted versions. Returns -1, 0 or 1. */
export function compareVersions(a: string, b: string): number {
  const pa = a.split(".").map(Number);
  const pb = b.split(".").map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const na = pa[i] || 0;
    const nb = pb[i] || 0;
    if (na < nb) return -1;
    if (na > nb) return 1;
  }
  return 0;
}
